import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=04edb8dc&scoped=true"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04edb8dc",
  null
  
)

export default component.exports